// Flag temporal para habilitar/deshabilitar la notificacion por correo del modulo.
// false: no solicita correo en UI y no intenta enviar notificacion en backend.
export const FEATURE_NOTIFICACION_CORREO_HABILITADA = false;